import { store } from 'MooTeam';

/**
 * Использовать authAliasSelector не получится, зацикливается импорт при инициализации приложения!!!
 * @param state
 * @returns {*}
 */
const getAliasSelector = (state) => {
  return state.getIn(['auth', 'alias']);
};

/**
 * Список ключей, которые являются общими для рабочих пространств
 * @type {string[]}
 */
const IGNORE_LIST = [process.env.REACT_APP_COOKIE_NAME];

const prepareName = (name) => {
  const isChange = !IGNORE_LIST.includes(name);
  // Не меняем cookie, если требуется изменить ключ и не инициализирован state
  if (isChange && !store) {
    return null;
  }

  if (isChange) {
    name = `${getAliasSelector(store.getState())}-${name}`;
  }

  return name;
};

/**
 * @description Creates new cookie with specified name, value and expiration time.
 * @param {string} name
 * @param {string} value
 * @param {number} expires
 */
export const setCookie = (name, value, expires) => {
  name = prepareName(name);
  if (!name) {
    return;
  }

  const newCookie = [
    name + '=' + (value && encodeURIComponent(value)),
    'path=/',
    'domain=' + process.env.REACT_APP_COOKIE_DOMAIN,
    'max-age=' + expires,
    'samesite=lax',
  ];

  document.cookie = newCookie.join(';');
};

/**
 * @description Returns cookie value by name
 * @param {string | null} name Cookie name
 * @returns {string | null} Cookie value
 */
export const getCookie = (name) => {
  name = prepareName(name);
  if (!name) {
    return;
  }

  const matches = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[]\\\/+^])/g, '\\$1') + '=([^;]*)'),
  );
  return matches ? decodeURIComponent(matches[1]) : null;
};

/**
 * @description Deletes specified cookie
 * @param {name} name Cookie name
 */
export const deleteCookie = (name) => {
  name = prepareName(name);
  if (!name) {
    return;
  }

  setCookie(name, null, -1);
};
